import { useMemo } from "react";
import { Provider } from "react-redux";
import MassSendHandwrittenCard from "./MassSendHandwrittenCard";

const MassSendHandwrittenCardApp = () => {
  const store = useMemo(() => ReactOnRails.getStore("layoutStore"), []);
  return (
    <Provider store={store}>
      <MassSendHandwrittenCard />
    </Provider>
  );
};

export default MassSendHandwrittenCardApp;
